import { observer } from 'mobx-react';
import { autoinject, Title } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { Button } from 'reactstrap';

@autoinject
@observer
export class ProductionHome extends React.Component<RouteComponentProps> {
    public render() {
        return (
            <div className="container-fluid">
                <Title>Production</Title>

                <div className="row">
                    <div className="col-12 mt-3">
                        <div className="jumbotron jumbotron-fluid">
                            <div className="container">
                                <h1 className="display-4">Welcome to SmartVu® Production</h1>
                                <p className="lead">This space will continue to grow and evolve to your needs.</p>

                                <h4 className="mt-5">Quick Links</h4>

                                <ul>
                                    <li>
                                        <LinkContainer to={`/software-updates/file-systems`}>
                                            <Button color="link" className="fw-bold">
                                                File Systems
                                            </Button>
                                        </LinkContainer>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
